import { render } from "./PreviewPanel.vue?vue&type=template&id=077bf099&scoped=true&ts=true"
import script from "./PreviewPanel.vue?vue&type=script&lang=ts"
export * from "./PreviewPanel.vue?vue&type=script&lang=ts"

import "./PreviewPanel.vue?vue&type=style&index=0&id=077bf099&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077bf099"]])

export default __exports__